import Layout from '../layout/Layout.vue'
import {
	createRouter,
	createWebHistory
} from "vue-router";


export const constantRoutes = [{
		path: '/login',
		name: 'Login',
		component: () => import("@/views/Login")
	},
	{
		path: '/Layout',
		name: 'Layout',
		component: Layout,
		children: [{
				path: '/home',
				name: 'Home',
				component: () => import("@/views/Home")
			},
			{
				path: '/allocation',
				name: 'Allocation',
				component: () => import("@/views/Allocation")
			},
			{
				path: '/competition',
				name: 'Competition',
				component: () => import("@/views/Competition")
			},
			{
				path: '/signup',
				name: 'Signup',
				component: () => import("@/views/Signup")
			},
			{
				path: '/publicize',
				name: 'Publicize',
				component: () => import("@/views/Publicize")
			},
			{
				path: '/goods',
				name: 'Goods',
				component: () => import("@/views/Goods")
			},
			{
				path: '/pointlist',
				name: 'Pointlist',
				component: () => import("@/views/Pointlist")
			},
			{
				path: '/selfInfo',
				name: 'SelfInfo',
				component: () => import("@/views/SelfInfo")
			},

		]
	},

]
const router = createRouter({
	routes: constantRoutes,
	history: createWebHistory(process.env.BASE_URL)
})
//路由守卫
router.beforeEach((to, from, next) => {
	//to 要访问的路径
	//from 代表从哪个路径跳转而来
	// next 是函数，表示放行
	// next() 放行
	// next('/*') 强制跳转
	const user = window.sessionStorage.getItem('user')
	if (to.path === '/login') {
		return next();
	}
	if (!user) {
		return next('/login')
	}
	if (to.path === '/' && user) {
		return next('/home')
	}
	next()
})

export default router